import { Injectable, Injector } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeOutService {

   private timeout: any;
  private idleTime = 10 * 60000; // 1 hr - time until warning popup
  private readonly activityEvents = ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'];
  private activityHandler = () => this.resetTimer();

  constructor(private injector: Injector) {}

  startWatching() {
    this.resetTimer(); // Start timer immediately
    this.activityEvents.forEach(event =>
      window.addEventListener(event, this.activityHandler)
    );
  }

  private resetTimer() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const auth = this.injector.get(AuthService);
      auth.isIdleLogout = true;
      auth.showIdleWarning(); // Show warning instead of immediate logout
    }, this.idleTime);
  }

  stopWatching() {
    this.activityEvents.forEach(event =>
      window.removeEventListener(event, this.activityHandler)
    );
    clearTimeout(this.timeout);
  }

}
